import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getItemGroupList as getItemGroupListApi,
	getWarehouseItemList as getWarehouseItemListApi,
	getWarehouseItemQuery as getWarehouseItemListQueryApi,
	getWarehouseItem as getWarehouseItemApi,
	addNewWarehouseItem as addNewWarehouseItemApi,
	updateWarehouseItem as updateWarehouseItemApi,
	deleteWarehouseItem as deleteWarehouseItemApi,
	checkWarehouseItemExists as checkWarehouseItemExistsApi,
	reserveWarehouseItem as reserveWarehouseItemApi,
	deliverWarehouseItem as deliverWarehouseItemApi,
	returnWarehouseItem as returnWarehouseItemApi,
	pickWarehouseItem as pickWarehouseItemApi,
	receiveWarehouseItem as receiveWarehouseItemApi,
	releaseWarehouseItem as releaseWarehouseItemApi,
	deliverWarehouseItemStockCheck as deliverWarehouseItemStockCheckApi
} from '../../helpers/warehouse/backend_helper';

export const getItemGroupList = createAsyncThunk('item_group/getItemGroupLis', async (params) => {
	try {
		const response = getItemGroupListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getWarehouseItemList = createAsyncThunk('warehouse_items/getWarehouseItemList', async (params) => {
	try {
		const response = getWarehouseItemListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getWarehouseItemListQuery = createAsyncThunk('warehouse_items/getWarehouseItemListQuery', async (params) => {
	try {
		const response = getWarehouseItemListQueryApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getWarehouseItem = createAsyncThunk('warehouse_items/getWarehouseItem', async warehouse_item_id => {
	try {
		const response = getWarehouseItemApi(warehouse_item_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewWarehouseItem = createAsyncThunk('warehouse_items/addNewWarehouseItem', async warehouse_item => {
	try {
		const response = addNewWarehouseItemApi(warehouse_item);
		toast.success('Item agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar la categoría.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateWarehouseItem = createAsyncThunk('warehouse_items/updateWarehouseItem', async (warehouse_item) => {
	try {
		const response = updateWarehouseItemApi(warehouse_item);
		toast.success('Item actualizado exitosamente', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar la categoría.', { autoClose: 3000 });
		throw new Error(error);
	}
}
);

export const deleteWarehouseItem = createAsyncThunk('warehouse_items/deleteWarehouseItem', async warehouse_item => {
	try {
		const response = await deleteWarehouseItemApi(warehouse_item);
		toast.success('Item eliminado exitosamente.', { autoClose: 3000 });
		return { warehouse_item, ...response };
	} catch (error) {
		toast.error('Error al eliminar la categoría.', { autoClose: 3000 });
		throw new Error(error);
	}
});


export const checkWarehouseItemExists = createAsyncThunk('warehouse_items/checkWarehouseItemExists', async name => {
	try {
		const response = await checkWarehouseItemExistsApi(name);
		if (response.exists) {
			toast.error('El item ya existe.', { autoClose: 3000 });
			throw new Error('Conflict');
		}
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});





export const reserveWarehouseItem = createAsyncThunk('warehouse_items/reserveWarehouseItem', async warehouse_item => {
	try {
		const response = await reserveWarehouseItemApi(warehouse_item);
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});

export const deliverWarehouseItem = createAsyncThunk('warehouse_items/deliverWarehouseItem', async (warehouse_item) => {
	try {
		const response = await deliverWarehouseItemApi(warehouse_item);
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});

export const pickWarehouseItem = createAsyncThunk('warehouse_items/pickWarehouseItem', async (warehouse_item) => {
	try {
		const response = await pickWarehouseItemApi(warehouse_item);
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});

export const returnWarehouseItem = createAsyncThunk('warehouse_items/returnWarehouseItem', async (warehouse_item) => {
	try {
		const response = await returnWarehouseItemApi(warehouse_item);
		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
});

export const receiveWarehouseItem = createAsyncThunk('warehouse_items/receiveWarehouseItem', async (warehouse_item) => {
	try {
		const response = await receiveWarehouseItemApi(warehouse_item);
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});

export const releaseWarehouseItem = createAsyncThunk('warehouse_items/releaseWarehouseItem', async warehouse_item => {
	try {
		const response = await releaseWarehouseItemApi(warehouse_item);
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});

export const deliverWarehouseItemStockCheck = createAsyncThunk('warehouse_items/deliverWarehouseItemStockCheck', async (warehouse_item, { rejectWithValue }) => {
	try {
		const response = await deliverWarehouseItemStockCheckApi(warehouse_item);
		return response;
	} catch (error) {
		return rejectWithValue(error.response?.data);
	}
});